import PropTypes from "prop-types";
import AnswerReviewCard from "./AnswerReviewCard";

const AnswerReviewList = ({
  answers,
  onShowExplanation,
}) => {
  if (!answers || answers.length === 0) {
    return (
      <div className="bg-white rounded-lg border p-5 text-center text-gray-500">
        No answers available for review.
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-semibold text-gray-800">
          Answer Review
        </h2>

        <span className="text-sm text-gray-500">
          {answers.length} Questions
        </span>
      </div>

      <div className="space-y-4">
        {answers.map((answer, index) => (
          <AnswerReviewCard
            key={answer.question?._id || answer.question || index}
            questionNumber={index + 1}
            answer={answer}
            onShowExplanation={onShowExplanation}
          />
        ))}
      </div>
    </div>
  );
};

AnswerReviewList.propTypes = {
  answers: PropTypes.arrayOf(
    PropTypes.shape({
      question: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
          _id: PropTypes.string,
          questionText: PropTypes.string,
          explanation: PropTypes.string,
          marks: PropTypes.number,
          options: PropTypes.arrayOf(
            PropTypes.oneOfType([
              PropTypes.string,
              PropTypes.shape({
                _id: PropTypes.string,
                key: PropTypes.string,
                text: PropTypes.string,
              }),
            ])
          ),
        }),
      ]),

      questionSnapshot: PropTypes.shape({
        questionText: PropTypes.string,
        explanation: PropTypes.string,
        options: PropTypes.arrayOf(
          PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.shape({
              _id: PropTypes.string,
              key: PropTypes.string,
              text: PropTypes.string,
            }),
          ])
        ),
      }),

      selectedAnswer: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
          key: PropTypes.string,
          text: PropTypes.string,
        }),
      ]),

      correctAnswer: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
          key: PropTypes.string,
          text: PropTypes.string,
        }),
      ]),

      isCorrect: PropTypes.bool,
      marksObtained: PropTypes.number,
    })
  ),

  onShowExplanation: PropTypes.func,
};

AnswerReviewList.defaultProps = {
  answers: [],
  onShowExplanation: () => {},
};

export default AnswerReviewList;